import React, { useEffect, useContext } from 'react';
import CargomaticCard from 'components/v2/card';
import { useTranslation } from 'react-i18next';
import CircleButton from 'components/v2/buttons/CircleButton';
import moment from 'moment';
import { showToast } from 'stores/ToastStore';
import formatMoney from 'utils/formatters/Money';
import DownloadIcon from '../../../v2/icons/DownloadIcon';
import { useGetSignedUrls } from '../../../../utils/DocumentsHooks';
import ArrowTopRightOnSquareIcon from '../../../v2/icons/ArrowTopRightOnSquareIcon';
function CreditMemoTable({ creditMemoList = [] }) {
    const { t } = useTranslation();
    return ((React.createElement(CargomaticCard, { dataTestId: "CargomaticCard-3d249252", className: "mb-6", header: () => (React.createElement("div", { "data-testid": "div-8a8c9c1c", className: "flex items-center justify-between" },
            React.createElement("h3", { "data-testid": "h3-bfb6b93e", className: "my-0 mr-8" }, t('CREDIT_MEMO', { count: 2 })))) },
        React.createElement("div", { "data-testid": "div-8354dcaa", className: "-mb-4 card--no-x-padding card--no-top-padding sm:-mb-4" },
            React.createElement("div", { "data-testid": "div-8769682e", className: "overflow-x-auto" },
                React.createElement("table", { "data-testid": "table-632bdc93", className: "default-table" },
                    React.createElement("thead", { "data-testid": "thead-b2b795a4", className: "text-bold" },
                        React.createElement("tr", { "data-testid": "tr-d08327ab" },
                            React.createElement("th", { "data-testid": "th-1732c57c", className: "" },
                                React.createElement("span", { "data-testid": "span-2089c6ec", className: "ml-6" }, t('NAME'))),
                            React.createElement("th", { "data-testid": "th-fb320ccb", className: "" }, t('AMOUNT')),
                            React.createElement("th", { "data-testid": "th-d535e48b", className: "" },
                                React.createElement("span", { "data-testid": "span-9fd1c1ea", className: "ml-4" }, t('DATE'))),
                            React.createElement("th", { "data-testid": "th-a7176149", className: "" },
                                React.createElement("span", { "data-testid": "span-61c25e58", className: "ml-6" },
                                    t('CREATED_BY'),
                                    " ")),
                            React.createElement("th", { "data-testid": "th-a6843d58", className: "" },
                                React.createElement("span", { "data-testid": "span-061c3e69", className: "ml-2" }, t('PDF'))))),
                    React.createElement("tbody", { "data-testid": "tbody-44ec6fdf", className: "" }, creditMemoList.map(({ number, amount_due: amountDue, timestamp: createdDate, created_by: createdBy, _id: id, currency, }, index) => {
                        return (React.createElement(CreditMemoRow, { number: number, amountDue: amountDue, createdDate: createdDate, id: id, createdBy: createdBy, currency: currency }));
                    }))))))));
}
const CreditMemoRow = ({ amountDue, createdBy, createdDate, id, number, currency, }) => {
    var _a, _b;
    const { t } = useTranslation();
    const { data: signedUrlsData, error: signedUrlsError } = useGetSignedUrls({
        foreignKeys: [id],
    });
    const signedUrl = (_b = (_a = signedUrlsData === null || signedUrlsData === void 0 ? void 0 : signedUrlsData.signedUrls) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.signedUrl;
    useEffect(() => {
        if (signedUrlsError) {
            showToast(t('GET_SIGNED_URL_ERROR'), t('GET_SIGNED_URL_FAILED_WITH_ERROR', {
                error: signedUrlsError,
            }), 'error');
        }
    }, [signedUrlsError]);
    return ((React.createElement("tr", { "data-testid": "tr-79b18f87" },
        React.createElement("td", { "data-testid": "td-fef41e98" },
            React.createElement("div", { "data-testid": "div-e5068598", className: "flex justify-start items-center" },
                React.createElement("a", { "data-testid": "a-cf2a79dd", className: "flex justify-start items-center", target: "_blank", href: `/invoices/${id}`, rel: "noreferrer" },
                    number,
                    React.createElement(ArrowTopRightOnSquareIcon, { className: "ml-1 w-5 h-5" })))),
        React.createElement("td", { "data-testid": "td-d88f99a9" },
            React.createElement("span", { "data-testid": "span-b1a39882", className: "" }, formatMoney(amountDue, currency))),
        React.createElement("td", { "data-testid": "td-da7842ab" }, moment(createdDate).format('L')),
        React.createElement("td", { "data-testid": "td-4b3b0b0d" }, createdBy),
        React.createElement("td", { "data-testid": "td-4c264c54", className: "cursor-pointer" },
            React.createElement(CircleButton, { dataTestId: "CircleButton-f90285ab", onClick: () => {
                    window.open(signedUrl, '_blank', 'noreferrer');
                } },
                React.createElement(DownloadIcon, null))))));
};
export default CreditMemoTable;
